module.exports = __webpack_public_path__ + "img/2.20732383.jpg";